import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LayoutModule, SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import { CustomerContactAddEditModalComponent } from './customer-contact-edit-modal.component';
@NgModule({
  declarations: [CustomerContactAddEditModalComponent],

  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LayoutModule,
    SharedModule,
    MaterialModule,
  ],
  entryComponents: [CustomerContactAddEditModalComponent]
})
export class CustomerContactDetailsModule { }
